import styled from 'styled-components';
import { COLORS } from '../../../app/common/constants/styles';
import { AgreementLink } from '../sharedStyles';

export const DeleteServicesContainer = styled.div`
    display: flex;
    margin-right: 36px;
    flex-direction: row-reverse;
    margin-bottom: 6px;
`;

export const DsrStatusContainer = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const DeleteServicesInfo = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: ${COLORS.dark};
    margin-left: 8px;
`;

export const DeleteServicesInfoText = styled.span`
    line-height: 1.2;
    display: block;
`;

export const DeleteServicesLink = styled.button`
    all: unset;
    font-size: 13px;
    color: ${COLORS.grey};
    cursor: pointer;

    &:hover {
        font-weight: bold;
        color: ${COLORS.grey4};
    }
`;

export const DeleteServicesRedLink = styled(AgreementLink)`
    margin-left: 1em;
`;

export const DeleteRequestAgain = styled(DeleteServicesInfo)`
    color: ${COLORS.darkRed};
    display: initial;
    margin-left: 5px;
    &:hover {
        font-weight: bold;
        cursor: pointer;
    }
`;

export const DataDownloadRequestInfoText = styled(DeleteServicesInfoText)`
    display: flex;
`;

export const DownloadDataLink = styled.button`
    all: unset;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
`;

export const DsrStatusInfoText = styled.div`
    margin: 30px 0px;
    line-height: 1.5;

    & p {
        margin: 0;
    }
`;

export const DsrStatusInfoLink = styled.button`
    all: unset;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const DsrModalActions = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 20px;

    & > button {
        max-width: 45%;
        width: 200px;
    }
`;
